import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Sankalpbyradhika() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/79988c04a9874f6a80f060906cdee2bf.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>ENGLISH SCIENCE</p>
          <h4>Sankalp : Complete Course on Physics for NDA - | 2022</h4> 
          <p>Ended on 4 Jun 2022 39 lessons</p> 
          <p>Radhika Sharma</p> 
        </div>
    </div>        
  )
}
export default Sankalpbyradhika;